import LocalizedStrings from 'components/localizedStrings';
import { SettingsInjections } from 'generics/settingsInjections';

export const _I_ = function(term) {
    return LocalizedStrings.processString(term, null, SettingsInjections.getUsedLocale().icon);
};

